import { Tooltip } from 'antd';

interface PjmLocationIdProps {
    value?: number | null;
}

export const PjmLocationId = ({ value }: PjmLocationIdProps) => {
    if (value == null) {
        return (
            <Tooltip title="The ID will become available once this record is synchronized with DRHUB.">
                <div style={{ color: '#c6c6c6', fontWeight: 700, cursor: 'pointer' }}>N/A</div>
            </Tooltip>
        );
    }

    return <>{value}</>;
};
